<template>
  <chi-default-section :menu="menu" :section="section" :menu-version="menu.menu_version"
                       class="menu--section-two_column"></chi-default-section>
</template>

<script lang="ts">
/**
 * Custom component for Bimini two column menu section layout.
 *
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 1.2.0
 * @copyright  Copyright (C) 2023-2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *    2023-03-23 (1.0.0) (jhoward)
 *      - <chi-two-section-column> adds a two column layout for CHI menu sections.
 *
 *    2025-03-18 (1.1.0) (jhoward)
 *      - Add support for textual menus in the <chi-two-section-column> component.
 *
 *  2025-04-08 (1.2.0) (jhoward)
 *    - Replace "menuVersion" prop with "menu" prop in <chi-two-section-column>.
 */

import {defineComponent, PropType} from "vue";
import ChiDefaultSection from "./Chi_defaultSection.vue";
import {Menu, MenuSection} from "../defs";

export default defineComponent({
  name: 'Chi_twoColumnSection',
  components: {ChiDefaultSection},
  props: {
    menu: {
      type: Object as PropType<Menu>,
      required: true
    },
    section: {
      type: Object as PropType<MenuSection>,
      required: true
    },
  },
})
</script>

<style scoped>

</style>